import axios from "axios";

/**
 * Installed Systems register + maintenance scheduling
 * (Installed_Systems_and_Maintenance_Scheduling spec, OM Part 16).
 * Gated server-side on route.installed_systems.
 */
export default {
  namespaced: true,
  state: {
    systems: [],
    loading: false,
    due_visits: [],
    due_loading: false,
  },
  getters: {
    systems(state) {
      return state.systems;
    },
    loading(state) {
      return state.loading;
    },
    due_visits(state) {
      return state.due_visits;
    },
    due_loading(state) {
      return state.due_loading;
    },
  },
  mutations: {
    SET_SYSTEMS(state, systems) {
      state.systems = systems;
    },
    ADD_SYSTEM(state, system) {
      state.systems.unshift(system);
    },
    EDIT_SYSTEM(state, system) {
      const i = state.systems.findIndex((s) => s.id == system.id);
      if (i !== -1) state.systems.splice(i, 1, system);
    },
    REMOVE_SYSTEM(state, id) {
      state.systems = state.systems.filter((s) => s.id != id);
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
    SET_DUE_VISITS(state, visits) {
      state.due_visits = visits;
    },
    SET_DUE_LOADING(state, val) {
      state.due_loading = val;
    },
  },
  actions: {
    async fetch_systems({ commit }, filters) {
      commit("SET_LOADING", true);
      try {
        const response = await axios.get("/installed_systems", {
          params: filters || {},
        });
        commit("SET_SYSTEMS", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async fetch_system(_ctx, id) {
      const response = await axios.get("/installed_system/" + id);
      return response.data;
    },
    async create_system({ commit }, payload) {
      const response = await axios.post("/installed_system", payload);
      commit("ADD_SYSTEM", response.data);
      return response.data;
    },
    async update_system({ commit }, { id, payload }) {
      const response = await axios.put("/installed_system/" + id, payload);
      commit("EDIT_SYSTEM", response.data);
      return response.data;
    },
    async delete_system({ commit }, id) {
      await axios.delete("/installed_system/" + id);
      commit("REMOVE_SYSTEM", id);
    },
    async fetch_due_visits({ commit }, params) {
      commit("SET_DUE_LOADING", true);
      try {
        const response = await axios.get("/maintenance_visits/due", {
          params: params || {},
        });
        commit("SET_DUE_VISITS", response.data);
        return response.data;
      } finally {
        commit("SET_DUE_LOADING", false);
      }
    },
    async setup_system({ commit }, { id, payload }) {
      const response = await axios.put("/installed_system/" + id + "/setup", payload);
      commit("EDIT_SYSTEM", response.data);
      return response.data;
    },
    async complete_visit(_ctx, { id, result }) {
      const response = await axios.put("/maintenance_visit/" + id + "/complete", {
        result,
      });
      return response.data;
    },
    async skip_visit(_ctx, { id, reason }) {
      const response = await axios.put("/maintenance_visit/" + id + "/skip", {
        reason,
      });
      return response.data;
    },
  },
};
